import undelegateListener from '../../off/_undelegatelistener.js';
import triggerOne from '../../trigger/_triggerone.js';
import isHeldByDataKey from './_isheldbydatakey.js';
// the function is called when data property is removed from Matreshka.Object
// it undelegates asterisk listener from removed object unless another data key still holds it
export default function objectRemoveHandler(_ref, _temp) {
  var key = _ref.key,
    item = _ref.value;
  var _ref2 = _temp === void 0 ? triggerOne.latestEvent.info.delegatedData : _temp,
    path = _ref2.path,
    name = _ref2.name,
    callback = _ref2.callback,
    context = _ref2.context,
    info = _ref2.info,
    object = _ref2.object;
  if (item && typeof item === 'object' && !isHeldByDataKey(object, item, key)) {
    undelegateListener(item, path, name, callback, context, info);
  }
}